const ScanIcon = ({ ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      {...props}
    >
      <path
        d='M1.16669 5.68734C0.92752 5.68734 0.729187 5.489 0.729187 5.24984V3.7915C0.729187 2.09984 2.10585 0.729004 3.79169 0.729004H5.25002C5.48919 0.729004 5.68752 0.927337 5.68752 1.1665C5.68752 1.40567 5.48919 1.604 5.25002 1.604H3.79169C2.58419 1.604 1.60419 2.584 1.60419 3.7915V5.24984C1.60419 5.489 1.40585 5.68734 1.16669 5.68734Z'
        fill='#292D32'
      />
      <path
        d='M12.8333 5.68734C12.5942 5.68734 12.3958 5.489 12.3958 5.24984V3.7915C12.3958 2.584 11.4158 1.604 10.2083 1.604H8.75C8.51083 1.604 8.3125 1.40567 8.3125 1.1665C8.3125 0.927337 8.51083 0.729004 8.75 0.729004H10.2083C11.8942 0.729004 13.2708 2.09984 13.2708 3.7915V5.24984C13.2708 5.489 13.0725 5.68734 12.8333 5.68734Z'
        fill='#292D32'
      />
      <path
        d='M10.2083 13.271H9.33331C9.09415 13.271 8.89581 13.0727 8.89581 12.8335C8.89581 12.5943 9.09415 12.396 9.33331 12.396H10.2083C11.4158 12.396 12.3958 11.416 12.3958 10.2085V9.3335C12.3958 9.09433 12.5941 8.896 12.8333 8.896C13.0725 8.896 13.2708 9.09433 13.2708 9.3335V10.2085C13.2708 11.9002 11.8941 13.271 10.2083 13.271Z'
        fill='#292D32'
      />
      <path
        d='M5.25002 13.2708H3.79169C2.10585 13.2708 0.729187 11.9 0.729187 10.2083V8.75C0.729187 8.51083 0.92752 8.3125 1.16669 8.3125C1.40585 8.3125 1.60419 8.51083 1.60419 8.75V10.2083C1.60419 11.4158 2.58419 12.3958 3.79169 12.3958H5.25002C5.48919 12.3958 5.68752 12.5942 5.68752 12.8333C5.68752 13.0725 5.48919 13.2708 5.25002 13.2708Z'
        fill='#292D32'
      />
      <path
        d='M8.16665 10.6457H5.83331C4.42165 10.6457 3.64581 9.86984 3.64581 8.45817V5.5415C3.64581 4.12984 4.42165 3.354 5.83331 3.354H8.16665C9.57831 3.354 10.3541 4.12984 10.3541 5.5415V8.45817C10.3541 9.86984 9.57831 10.6457 8.16665 10.6457ZM5.83331 4.229C4.91165 4.229 4.52081 4.61984 4.52081 5.5415V8.45817C4.52081 9.37984 4.91165 9.77067 5.83331 9.77067H8.16665C9.08831 9.77067 9.47915 9.37984 9.47915 8.45817V5.5415C9.47915 4.61984 9.08831 4.229 8.16665 4.229H5.83331Z'
        fill='#292D32'
      />
      <path
        d='M11.0834 7.4375H2.91669C2.67752 7.4375 2.47919 7.23917 2.47919 7C2.47919 6.76083 2.67752 6.5625 2.91669 6.5625H11.0834C11.3225 6.5625 11.5209 6.76083 11.5209 7C11.5209 7.23917 11.3225 7.4375 11.0834 7.4375Z'
        fill='#292D32'
      />
    </svg>
  );
};

export default ScanIcon;
